import Navigation from "../../components/navigation/Navigation";
import {theme} from "../../shared/theme/theme";
import {Box} from "@mui/material";

const DefaultLayout = (props) => {
    return (
        <>
            <Navigation/>
            <Box sx={{
                marginLeft: "0",
                marginTop: "56px",
                padding: "1em",
                [theme.breakpoints.up('sm')]: {
                    marginLeft: "240px",
                    marginTop: "64px"
                }
            }}
            >
                {props.children}
            </Box>
        </>


    )
}

export default DefaultLayout